import React from 'react';
import { useParams } from 'react-router-dom';

export default function QuotationReview() {
    const quotationId = useParams().id;
    const url = `https://rlugroup.in/pdf/convert?fileName=rlugroup.hbs&url=${process.env.REACT_APP_API_BASE_URL}/quotations/data/${quotationId}`;
    return (
        <object data={url} type="application/pdf" width="100%" height={window.innerHeight} aria-label="Quotation PDF">
            Quotation PDF
        </object>
    )
}
